import { render, staticRenderFns } from "./PmConfigDialog.vue?vue&type=template&id=4727a832&scoped=true"
import script from "./PmConfigDialog.vue?vue&type=script&lang=js"
export * from "./PmConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./PmConfigDialog.vue?vue&type=style&index=0&id=4727a832&prod&scoped=true&lang=css"
import style1 from "./PmConfigDialog.vue?vue&type=style&index=1&id=4727a832&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4727a832",
  null
  
)

export default component.exports